import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Tables from './pages/Tables';
import Order from './pages/Order';
import Stats from './pages/Stats';
import Kitchen from './pages/Kitchen';
import Stations from './pages/Stations';
import MenuAdmin from './pages/MenuAdmin';
import ModifierGroups from './pages/ModifierGroups';
import TablesAdmin from './pages/TablesAdmin';
import MenuSettings from './pages/MenuSettings';
import History from './pages/History';
import Users from './pages/Users';
import Attendance from './pages/Attendance';
import Settings from './pages/Settings';
import Invoices from './pages/Invoices';
import Cash from './pages/Cash';
import CashToday from './pages/CashToday';
import Payroll from './pages/Payroll';
import Contractors from './pages/Contractors';
import Reservations from './pages/Reservations';
import Payables from './pages/Payables';
import PinScreen from './pages/PinScreen';
import './App.css';

function PrivateRoute({ children }) {
  const { rawUser, terminalUser, isTerminal, loading } = useAuth();
  if (loading) return <div className="page-loading">Ładowanie...</div>;
  if (!rawUser) return <Navigate to="/login" replace />;
  if (isTerminal && !terminalUser) return <PinScreen />;
  return children;
}


function KitchenRoute() {
  const { rawUser, loading } = useAuth();
  if (loading) return <div className="page-loading">Ładowanie...</div>;
  if (!rawUser) return <Navigate to="/login" replace />;
  return <Kitchen />;
}

function HomeRoute() {
  const { rawUser, loading } = useAuth();
  if (loading) return null;
  if (rawUser?.role === 'kitchen') return <Navigate to="/kitchen/zbiorczy" replace />;
  return <Tables />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/kitchen/:slug" element={<KitchenRoute />} />
          <Route path="/" element={
            <PrivateRoute><Layout /></PrivateRoute>
          }>
            <Route index element={<HomeRoute />} />
            <Route path="order/:tableId" element={<Order />} />
            <Route path="stats" element={<Stats />} />
            <Route path="history"     element={<History />} />
            <Route path="invoices"    element={<Invoices />} />
            <Route path="cash"        element={<Cash />} />
            <Route path="cash-today"  element={<CashToday />} />
            <Route path="payroll"     element={<Payroll />} />
            <Route path="contractors" element={<Contractors />} />
            <Route path="contractors/:id" element={<Contractors />} />
            <Route path="reservations" element={<Reservations />} />
            <Route path="payables" element={<Payables />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="menu"         element={<MenuSettings />} />
            <Route path="users"        element={<Users />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
